import { addFavoriteToCandidate } from "./addFavoriteToCandidate";
import { candidateGetAppliedPositions } from "./candidateGetAppliedPositions";
import { getJobListUrl } from "./getJobListUrl";
import { getJobPictureUrl } from "./getJobPictureUrl";
import { getCandidateFavorites } from "./getCandidateFavorites";
import { getCurrentApplicationItem } from "./getCurrentApplicationItem";
import { getJobFull } from "./getJobFull";
import { getJobs } from "./getJobs";
import { removeFavoriteFromCandidate } from "./removeFavoriteFromCandidate";
import { startApplyForCurrentPosition } from "./startApplyForCurrentPosition";

export const jobsAPI = {
  getJobs,
  getJobFull,
  getJobListUrl,
  getJobPictureUrl,
  getCandidateFavorites,
  addFavoriteToCandidate,
  removeFavoriteFromCandidate,
  startApplyForCurrentPosition,
  getCurrentApplicationItem,
  candidateGetAppliedPositions,
};

export type JobsAPI = typeof jobsAPI;
